import React from 'react';

export const LoadingSpinner: React.FC<{ message: string }> = React.memo(({ message }) => (
  <div className="h-full flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
));

export const NoConfigMessage: React.FC<{ message: string }> = React.memo(({ message }) => (
  <div className="h-full flex items-center justify-center">
    <div className="text-center">
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
));

// Factory functions to create components with specific messages
export const createLoadingComponent = (message: string): React.ComponentType => {
  return () => <LoadingSpinner message={message} />;
};

export const createNoConfigComponent = (message: string): React.ComponentType => {
  return () => <NoConfigMessage message={message} />;
}; 